import * as React from 'react'
import {useSelector} from 'react-redux'
import View from '../../components/organisms/Indicator'
import * as appSelectors from '../../selectors/app'

export default function ApplicationIndicator() {
  const busy = useSelector(appSelectors.getBusy)
  return busy ? React.createElement(View) : null
}
